import PropTypes from 'prop-types';
import * as React from 'react';

const Trash = React.forwardRef(({ color = 'currentColor', size, strokeWidth = 1.2, ...rest }, ref) => {
  const DEFAULT_W = 18;
  const DEFAULT_H = 20;
  const width = size ?? DEFAULT_W;
  const height = size ?? DEFAULT_H;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="M1 4.176h16M6 1h6M7 14.765V8.412m4 6.353V8.412M12.5 19h-7c-1.105 0-2-.948-2-2.118L3.043 5.28c-.023-.601.43-1.103 1-1.103h9.915c.568 0 1.022.502.999 1.103L14.5 16.882c0 1.17-.895 2.118-2 2.118" />
    </svg>
  );
});

Trash.displayName = 'Trash';

Trash.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Trash;
